import * as React from 'react';

interface MultiLineButtonProps {
    onClick: () => void;
    firstLine: string;
    secondLine?: string;
    className?: string;
}

export const MultiLineButton = ({ onClick, firstLine, secondLine, className }: MultiLineButtonProps) => {
    return (
        <button className={`flex flex-col text-white bg-sh-red p-2 rounded-[3px] ${className}`} onClick={onClick}>
            <div className="uppercase tracking-[0.22em] font-bold text-[14px] leading-[20px]">{firstLine}</div>
            {secondLine && <div className='text-[13px] leading-[20px] opacity-80 tracking-wide font-medium'>{secondLine}</div>}
        </button>
    )
}